import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCreateGoogleAuth } from '../services/react-query/integrations/google_calendar/useGoogleAuthCallback';
import { Loading } from '../uikit';

export const GoogleOAuthCallback = () => {
  const location = useLocation();
  const { mutate: createGoogleAuth } = useCreateGoogleAuth();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get('code');
    if (code) {
      createGoogleAuth(code);
    }
  }, [location]);

  return <Loading />;
};
